import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_BANDITS_PSF_COMBO_EXPERIMENT = defineFcm('revenue_bandits_psf_combo_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string', optional: true },
				exp_name_suffix: { type: 'string', optional: true },
				treatment_traffic_percentage: { type: 'number', minimum: 0, maximum: 100 },
				enabled: { type: 'boolean' },
				bandit_amounts: {
					type: 'array',
					shape: {
						type: 'number',
					},
					optional: true,
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
